import { z } from "zod";
import { schemes } from "../schema-validation";

export const orderPaymentShareableLinksTokenPayloadSchema = z.object({
  companyID: schemes.companyID(),
  customerAccountID: schemes.uuid(),
  orderID: schemes.uuid(),
  isShareableLink: z.literal(true),
  testMode: z.boolean(),
  whiteLabelID: z.string(),
});

export const orderPaymentInformationCompanySchema = z.object({
  company_id: schemes.companyID(),
  business_name: z.string(),
});

export const orderPaymentInformationPayloadSchema = z.object({
  company: orderPaymentInformationCompanySchema,
  logoURL: z.string().nullish(),
  tokenPayload: orderPaymentShareableLinksTokenPayloadSchema,
});

export type TOrderPaymentShareableLinksTokenPayload = z.infer<
  typeof orderPaymentShareableLinksTokenPayloadSchema
>;
export type TOrderPaymentInformationPayload = z.infer<
  typeof orderPaymentInformationPayloadSchema
>;
